import { Component, OnInit , Input , Output,EventEmitter,ViewChild } from '@angular/core';

@Component({
  selector: 'file-upload',
  templateUrl: './file.upload.html'
})
export class FileUploadComponent {
   @Input() titels: string ; 
   @Input() file_Photo: string ; 
   @Output() ControlName = new EventEmitter<File>(); 
   @ViewChild('myInput') myInputVariable: any;
   
  constructor() { } 
  public fileChange(event){ 
    let fileList: FileList = event.target.files;
    this.setImgType(fileList[0]);
    
  }
  public setImgType(file){
    this.ControlName.emit(file);
    this.readFiles(file);
  }
  public reset() {
    this.myInputVariable.nativeElement.value = "";
  }
  public readFiles(files){
    // Create the file reader
    let reader = new FileReader();
    
      // Start reading this file
      this.readFile(files, reader, (result) =>{
        // Create an img element and add the image file data to it
        var img = document.createElement("img");
        img.src = result;
        // Send this img to the resize function (and wait for callback)
        this.resize(img, 100, 100, (resized_jpeg, before, after)=>{
          this.setImg(resized_jpeg);
        });
      });
  }
  setImg(imgData){ 
     this.file_Photo=imgData;
  }
  readFile(file, reader, callback){
    // Set a callback funtion to fire after the file is fully loaded
    reader.onload = () => {
      // callback with the results
      callback(reader.result);
    }
    
    // Read the file
    reader.readAsDataURL(file);
  }
  resize(img, MAX_WIDTH:number, MAX_HEIGHT:number, callback){
    // This will wait until the img is loaded before calling this function
    return img.onload = () => {
      console.log("img loaded");
      // Get the images current width and height
      var width = img.width;
      var height = img.height;
      
      // Set the WxH to fit the Max values (but maintain proportions)
      if (width > height) {
          if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
          }
      } else {
          if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
          }
      }
      
      // create a canvas object
      var canvas = document.createElement("canvas");
    
      // Set the canvas to the new calculated dimensions
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");  

      ctx.drawImage(img, 0, 0,  width, height); 
      
      // Get this encoded as a jpeg
      // IMPORTANT: 'jpeg' NOT 'jpg'
      var dataUrl = canvas.toDataURL('image/jpeg');
      
      // callback with the results
      callback(dataUrl, img.src.length, dataUrl.length);
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/common/file-upload/file.upload.ts